import { render, staticRenderFns } from "./CustomerReport.vue?vue&type=template&id=a225d01c"
import script from "./CustomerReport.vue?vue&type=script&lang=js"
export * from "./CustomerReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports